// stati di una richiesta di avviso, come li calcola il backend (features/alerts/service.js statusOf)
export const STATI = {
	waiting: { label: 'In attesa', colore: 'orange darken-1', icona: 'mdi-timer-sand' },
	sent: { label: 'Inviato', colore: 'primary', icona: 'mdi-email-check-outline' },
	converted: { label: 'Convertito', colore: 'green darken-1', icona: 'mdi-cart-check' },
	cancelled: { label: 'Annullato', colore: 'grey darken-1', icona: 'mdi-close-circle-outline' },
	discontinued: { label: 'Fuori produzione', colore: 'grey darken-1', icona: 'mdi-package-variant-remove' },
};

// i due tipi di avviso: sono le schede della pagina e il filtro "type" della lista
export const TIPI = [
	{
		value: 'available',
		label: 'Torna disponibile',
		icona: 'mdi-bell-ring-outline',
		vuoto: 'Le richieste arrivano dal modulo «Avvisami quando torna disponibile» dei prodotti esauriti, attivo da Ecommerce → Layout → Funzioni del sito.',
	},
	{
		value: 'price',
		label: 'Prezzo in calo',
		icona: 'mdi-tag-arrow-down-outline',
		vuoto:
			'Le richieste arrivano dal modulo «Avvisami se il prezzo scende» della scheda prodotto, attivo da Ecommerce → Layout → Funzioni del sito. Per l’invio serve il modello email «Notifica quando il prezzo scende».',
	},
];

export const stato = codice => STATI[codice] || { label: codice || '—', colore: 'grey', icona: 'mdi-help-circle-outline' };
